import styled from 'foundations-theming/utils';
export const HeaderLeftBorder = styled.div.withConfig({
  displayName: "HeaderLeftBorder",
  componentId: "sc-4yi0xy-0"
})(["inline-size:", ";block-size:100%;", ""], ({
  theme
}) => theme.space['250'], ({
  $shouldHighlight,
  theme
}) => $shouldHighlight ? `border-left: ${theme.borderWidth['200']} solid ${theme.color['fill-info-default']};` : '');